import { ApiCart } from './models/cart/class.model.cart';

window._ = require('lodash');

import { createApp } from 'vue';
import { router } from './routes';
import Kiosk from './components/kiosk/Kiosk';
import Lang from 'lang.js';
import {
    callAPI,
    countElements,
    formatCurrency,
    isset,
    generateOperatorUID
} from './helpers/kiosk-helpers';
import InvoiceTemplate1 from './components/invoices/template1';

window.Vue = require('vue');

/*
BOOTSTRAP JS
 */
try {
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) {
    //
}

/*
AXIOS
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/*
SEATING CHART
*/
window.seating_chart_info = {};

const messages = window.messages;

const app = createApp({
    components: {
        'kiosk-component': Kiosk,
    },

    data() {
        return {
            cart_is_loaded: false,
            product_is_loaded: false,
            cart: {},
            cart_products: {},
            cart_products_seating_chart: {},
            cart_products_quantity: [],
            cart_is_empty: true,
            keep_alive_interval: null,
            store_id: parseInt(window.localStorage.getItem('xpayrience_store_id')),
            store_uid: 'configuration',
            cart_items: null,
            api_auth_tokens_valid: false,
            access_token: null,
            token_id: null,
            locale: window.locale,
            current_user_id: null,
            current_event_is_loaded: [],
            disabled_next_btn: true,
            ticketing: {},
            has_call_ajax: [],
            current_loading_message: '',
            errors: [],
            /* seulement 1 event a fois */
            current_event: null,
            event_list: [],
            seating_chart_uid: [],
            taxes: [],
            all_fees: {},
            fees: 0,
            seating_chart_info: {},
            seating_chart_scripts_are_loaded: false,
            global_cancel_btn_disabled: false,
            seating_place_info: [],
            show_btn_confirmer: true,
            app_is_loaded: false,
            time_end: null,
            time_left: null,
            second_left: null,
            time_converted: null,
            time_interval: null,
            order_id: null,
            /* List des invoices */
            previous_order: [],
            admin_show: false,
            current_tpv: localStorage.getItem('BorneTpv_uid'),
            current_opererator: localStorage.getItem('BorneOperator'),
            current_tpv_id: localStorage.getItem('BorneTpv_id'),
            current_session_id: localStorage.getItem('x-xpayrience-sessionid'),
            /* l'invoice courrante */
            invoice: {},
            invoice_loaded: false,
            current_kiosk_version: localStorage.getItem('current-kiosk-version'),
            banners: [],
            has_seating_chart: false,
            borne_configuration: {},
            clear_only_time: false,
            call_ajax_list: [],
            errors_tpv: {},
            borne_url: '',
        };

    },

    watch: {
        app_is_loaded(value) {
            if (value === true) {
                this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded, 'loading-app');
            }
        },
        time_end(value) {
            this.change_time(this.time_end);
        },
        has_call_ajax(value) {
            if (this.has_call_ajax.length <= 0) {
                this.scrollbarVisible();
            }
        },
        current_opererator(value) {
            localStorage.setItem('BorneOperator', value);
        },
        current_tpv(value) {

            if (value != '') {

                if (this.current_opererator === null) {
                    this.current_opererator = generateOperatorUID();
                }

                let operator = {};
                operator['operator_uid'] = this.current_opererator;

                callAPI(route('api.stores.devices.store'), {
                    store_id: this.$root.store_id,
                    selected_device_uid: value,
                    operators: [operator],
                }, 'post')
                    .then(response => {
                        if (response['data']['success'] === 1) {

                            if (typeof response['data']['hardware_device'] !== 'undefined' && typeof response['data']['hardware_device']['idx'] !== 'undefined') {
                                this.current_tpv_id = response['data']['hardware_device']['idx'];
                            }
                        } else {
                            this.addErrors('a-202', null, 'Response fail');
                        }
                    })
                    .catch(error => {
                        this.addErrors('a-202-2', null, String(error));
                    });
            }
        },
        current_tpv_id(value) {
            localStorage.setItem('BorneTpv_id', value);
            this.set_tpv_to_session();
        },
    },

    methods: {
        init() {
            this.borne_url = window.location.origin;

            this.set_borne_configuration();
            this.init_errors_tpv();

            this.ticketing.item = [];
            if (this.loadAccessToken()) {
                this.checkConnexion()
                    .then(() => {
                        this.setKeepAliveInterval();
                    })
                    .then(() => {
                        this.getEventsList()
                            .then(() => {
                                this.refreshCart()
                                    .then(() => {
                                    });
                            })
                            .catch(error => {
                                this.addErrors('a-100', null, String(error));
                            });
                    })
                    .catch(error => {
                        this.addErrors('a-100-2', null, String(error));
                    });

            }
        },
        init_errors_tpv() {
            /* filtre les erreur possible du tpv */
            this.errors_tpv.tpv_01 = 'Unable to contact payfacot api';
            this.errors_tpv.tpv_02 = '[SALE_SWIPE_INSERT_TAP_KEY_TIMEOUT]';
            this.errors_tpv.tpv_03 = '[SALE_SWIPE_INSERT_TAP_KEY_CANCEL]';
            this.errors_tpv.tpv_04 = '[Magnetic card reading error]';
            this.errors_tpv.tpv_05 = '[Refer to the card issuer]';
        },

        addErrors(code, end_time = null, extra_data = '') {
            /* Function to add errors code */
            if (end_time != null) {
                setTimeout(this.removeErrors, end_time);
            }
            this.errors.push({ code: code });

            this.send_event_log('Borne erreur', code, extra_data);
        },

        send_event_log(event_name, event_data, extra_data = '', event_reference = 'borne', event_log_token = '830266bc8848e9e0b62835f6516d9327') {
            /* envoi les erreur a l'admin */
            let data = {};
            data.message_erreur = event_data;
            data.cart = this.cart;
            data.cart_products = this.cart_products;
            data.current_kiosk_version = this.current_kiosk_version;
            data.store_id = this.store_id;
            data.access_token = this.access_token;
            data.token_id = this.token_id;
            data.locale = this.locale;
            data.current_user_id = this.current_user_id;
            data.order_id = this.order_id;
            data.current_session_id = this.current_session_id;
            data.invoice = this.invoice;
            data.extra_data = extra_data;

            data = JSON.stringify(data);

            return new window.Promise((resolve, reject) => {
                callAPI(route('api.eventlog.error'), {
                    event_name: event_name,
                    event_data: data,
                    event_reference: event_reference,
                    event_log_token: event_log_token
                }, 'post')
                    .then(response => {
                        resolve('success');
                    })
                    .catch(error => {

                        reject(error);
                    });
            });
        },

        arrayFind(arr, value) {
            return arr.filter(function (elem) {
                return elem !== value;
            });
        },

        arrayRemove(arr, value) {
            return arr.filter(function (elem) {
                return elem !== value;
            });
        },

        cancel() {
            /* Cancel everything */
            this.cancel_time();

            if (Object.keys(window.seating_chart_info).length !== 0) {
                window.seating_chart_info['seating_chart_app'].Destroy();
                window.seating_chart_info = {};
            }

            this.current_loading_message = this.trans.get('kiosk.loading-cancel');
            this.has_call_ajax.push('Cancel');
            this.cart.clear()
                .then(() => {
                    this.refreshCart()
                        .then(() => {
                            this.has_call_ajax = [];
                            this.current_event_is_loaded = [];

                            this.$router.push({ name: this.locale + '.home' })
                                .then(() => {
                                });

                        })
                        .catch(error => {
                            this.addErrors('a-100', null, String(error));
                        });

                })
                .catch(error => {
                    this.addErrors('a-111-2', null, String(error));
                });

        },

        cancel_time() {

            /* Function to cancel order timer */
            if (this.time_interval != null) {
                clearInterval(this.time_interval);
            }

            this.time_end = null;
            this.time_left = null;
            this.second_left = null;
            this.time_converted = null;
            this.time_interval = null;
        },

        cartItemsCount() {
            return Object.keys(this.cart_products).length;
        },

        change_time(time) {
            if (time !== null) {
                this.time_left = time;
                let second_left = (this.time_left - new Date().getTime()) / 1000;
                second_left = Math.floor(second_left);

                this.second_left = second_left;

                if (this.time_interval !== null) {
                    clearInterval(this.time_interval);
                    this.time_interval = null;
                }

                this.time_interval = setInterval(() => {
                    this.interval_time();
                }, 1000);
            }
        },

        checkConnexion() {
            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.validate-tokens'))
                    .then(response => {
                        if (!this.isConnected(response)) {
                            clearInterval(this.keep_alive_interval);
                            this.api_auth_tokens_valid = false;
                            this.$router.push({ name: this.locale + '.configuration' })
                                .then(() => {
                                });
                            return;
                        }

                        window.localStorage.setItem(
                            'x-xpayrience-sessionid',
                            response['data']['xpayrience_session_id']
                        );
                        this.store_uid = response['data']['current_store']['uid'];

                        this.current_session_id = response['data']['xpayrience_session_id'];

                        window.current_user_id = response['data']['user_id'];
                        this.current_user_id = response['data']['user_id'];
                        window.api_auth_tokens = response['data']['api_auth_tokens'];
                        this.api_auth_tokens_valid = true;
                        //this.active_component = this.catalog_component;
                        resolve('success');
                    })
                    .catch(error => {
                        this.addErrors('a-102', null, String(error));
                        clearInterval(this.keep_alive_interval);
                        this.api_auth_tokens_valid = false;
                        this.$router.push({ name: this.locale + '.configuration' });
                        reject(error);
                    });
            });
        },

        clearCart() {
            if (Object.keys(this.seating_chart_info).length !== 0) {
                this.seating_chart_info['seating_chart_app'].Destroy();
                this.seating_chart_info = {};
            }

            this.cart.clear()
                .then(() => {
                    this.refreshCart()
                        .then(() => {
                            this.has_call_ajax = this.arrayRemove(this.has_call_ajax, 'Cancel');
                            this.cancel_time();
                        })
                        .catch(error => {
                            this.addErrors('a-112', null, String(error));

                        });

                })
                .catch(error => {
                    this.addErrors('a-112-2', null, String(error));
                });
        },

        createCartItem(item) {
            let cart_item_data = {
                product_id: item.product_id,
                store_id: item.store_id,
                quantity: item.quantity,
                event_id: item.event_id,
                generate_ca: true
            };

            let i = 0;
            while (this.has_call_ajax.includes('create-' + i)) {
                i++;
            }

            let val = 'create-' + i;
            this.has_call_ajax.push(val);
            this.cart.createItemQty(cart_item_data)
                .then(() => {
                    /* 10 min */
                    this.time_end = new Date().getTime() + (10 * 60000);
                    this.has_call_ajax = this.arrayRemove(this.has_call_ajax, val);
                })
                .catch(error => {
                    this.has_call_ajax = this.arrayRemove(this.has_call_ajax, val);
                    this.addErrors('a-101', null, String(error));
                });

        },

        deleteCartItem(item) {
            let cart_item_data = {
                product_id: item.product_id,
                store_id: item.store_id,
                quantity: item.quantity,
                event_id: item.event_id
            };

            let i = 0;
            while (this.has_call_ajax.includes('delete-' + i)) {
                i++;
            }

            let val = 'delete-' + i;
            this.has_call_ajax.push(val);

            this.cart.deleteItemByProductIdQty(cart_item_data)
                .then(() => {
                    this.has_call_ajax = this.arrayRemove(this.has_call_ajax, val);
                })
                .catch(error => {
                    this.addErrors('a-109', null, String(error));
                });

        },

        deleteCartItemByIdx(idx) {

            let i = 0;
            while (this.has_call_ajax.includes('delete-' + i)) {
                i++;
            }

            let val = 'delete-' + i;
            this.has_call_ajax.push(val);

            return new window.Promise((resolve, reject) => {
                this.cart.deleteItemByIdx(idx)
                    .then(() => {
                        this.has_call_ajax = this.arrayRemove(this.has_call_ajax, val);
                        resolve('ok');
                    })
                    .catch(error => {
                        this.addErrors('a-120', null, String(error));
                        reject(error);
                    });
            });

        },

        endOrder() {
            if (Object.keys(this.seating_chart_info).length !== 0) {
                this.seating_chart_info['seating_chart_app'].Destroy();
                this.seating_chart_info = {};
            }

            this.cart.clear()
                .then(() => {
                    this.refreshCart()
                        .then(() => {
                            this.has_call_ajax = this.arrayRemove(this.has_call_ajax, 'Cancel');
                        })
                        .catch(error => {
                            this.addErrors('a-113', null, String(error));
                            reject(error);
                        });

                })
                .catch(error => {
                    this.addErrors('a-113-2', null, String(error));
                    reject(error);
                });
        },

        getEventsList() {
            this.event_list = [];
            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.events.index', { store_id: this.store_id }))
                    .then(response => {
                        /*******************************************************
                         NEXT EVENT
                         *******************************************************/
                        if (isset(response['data']['next_event'])) {
                            if (countElements(response['data']['next_event']) > 0) {
                                this.event_list[response['data']['next_event']['idx']] = response['data']['next_event'];
                            }

                        }
                        /*******************************************************
                         FUTURE EVENTS
                         *******************************************************/

                        if (isset(response['data']['events'])) {
                            if (countElements(response['data']['events']) > 0) {
                                for (const [key, value] of Object.entries(response['data']['events'])) {
                                    this.event_list[value.idx] = value;
                                }
                            }
                        }

                        resolve('ok');
                    })
                    .catch(error => {
                        this.addErrors('a-114', null, String(error));
                        reject(error);
                    });
            });

        },

        getSeatingChartInfo(p_product_id, p_event_id) {
            return new window.Promise((resolve, reject) => {
                callAPI(route('api.store.seating_charts.getSeatingChartInfo',
                    {
                        product_id: this.p_product_id,
                        event_id: this.p_event_id
                    }))
                    .then(response => {

                        if (isset(response['data']['st'])) {
                            if (countElements(response['data']['seating_chart_info']) > 0) {
                                this.seating_chart_uid[response['data']['event_id']] = response['data']['seating_chart_info'];
                            }
                        }
                        resolve('ok');
                    })
                    .catch(error => {
                        this.addErrors('a-115', null, String(error));
                        reject(error);
                    });
            });
        },

        getSubTotal(format = true) {
            if (format === true) {
                return formatCurrency(this.cart.price_total_infos.subtotal);
            } else {
                return this.cart.price_total_infos.subtotal;
            }
        },

        get_time_left_converted() {
            return this.time_left;
        },

        getTotal(format = true) {
            if (format === true) {
                return formatCurrency(this.cart.price_total_infos.total);
            } else {
                return this.cart.price_total_infos.total;
            }
        },

        getTransactionFees(format = true) {
            let total = this.getTotal(false);
            let stotal = this.getSubTotal(false);
            let taxes = 0;
            let list_taxes = this.getTaxes();

            if (list_taxes !== null && typeof list_taxes !== 'undefined') {
                for (const [key, value] of Object.entries(list_taxes)) {
                    taxes += value.price;
                }
            }

            let fees = total - stotal - taxes;

            if (format === true) {
                return formatCurrency(fees);
            } else {
                return fees;
            }
        },

        getTaxes() {
            return this.cart.price_total_infos.taxes;
        },

        interval_time() {
            if (this.second_left != null) {
                this.second_left--;

                if (this.second_left <= 0) {
                    this.second_left = null;
                    if (this.time_interval != null) {
                        clearInterval(this.time_interval);
                        this.time_interval = null;
                    }
                    this.cancel();
                }

                // let second_left = this.second_left;
                let min = 0;
                let sec = 0;
                min = Math.floor(this.second_left / 60);
                sec = this.second_left % 60;
                if (sec < 10) {
                    sec = '0' + sec;
                }

                this.time_converted = min + ':' + sec;
            }
        },

        isConnected(response) {
            if (!isset(response['data'])) {
                return false;
            }

            if (!isset(response['data']['success'])) {
                return false;
            }

            return parseInt(response['data']['success']) === 1;
        },

        keepAliveResponseIsValid(response) {
            if (response['status'] !== 200) {
                return false;
            }

            if (!isset(response['data'])) {
                return false;
            }

            if (!isset(response['data']['success']) || !isset(response['data']['xpayrience_session_id'])) {
                return false;
            }

            return parseInt(response['data']['success']) === 1;

        },

        keepAlive() {
            callAPI(route('api.kiosk.keep-alive'))
                .then(response => {
                    if (!this.keepAliveResponseIsValid(response)) {
                        clearInterval(this.keep_alive_interval);

                        if (isset(response['data']['errno'])) {
                            if (response['data']['errno'] === '0xA0001') {
                                window.localStorage.delFromStorage('xpayrience_session_id');
                            }
                        }

                        this.$router.push({ name: this.locale + '.configuration' });
                        return;
                    }

                    window.localStorage.setItem('xpayrience_session_id', response['data']['xpayrience_session_id']);
                })
                .catch(error => {
                    this.addErrors('a-103', null, String(error));
                    clearInterval(this.keep_alive_interval);
                    this.$router.push({ name: this.locale + '.configuration' });
                });
        },

        loadAccessToken() {
            let token_id = window.localStorage.getItem('xpayrience_token_id');
            let access_token = window.localStorage.getItem('xpayrience_access_token');
            /*
            console.log('token_id: ' + token_id);
            console.log('access_token: ' + access_token);
            */
            if (isset(token_id) && isset(access_token)) {
                this.token_id = token_id;
                this.access_token = access_token;

                return true;
            } else {
                this.$router.push({ name: this.locale + '.configuration' });
                return false;
            }
        },

        loadCart() {
            return new window.Promise((resolve, reject) => {
                ApiCart.load()
                    .then(cart => {
                        this.cart = cart;
                        this.cart_is_loaded = true;
                        resolve('ok');
                    })
                    .catch(error => {
                        this.addErrors('a-105', null, String(error));
                        reject('a-105');
                    });
            });
        },

        reduce_time() {
            this.time_left -= 1000;
        },

        refreshCart() {
            return new window.Promise((resolve, reject) => {

                this.loadCart()
                    .then(() => {
                        this.cart.items()
                            .products()
                            .then(products => {
                                let products_key = Object.keys(products);
                                this.cart_products_seating_chart = {};

                                if (products_key.length > 0) {
                                    this.cart_products = products;

                                    for (let i = 0; i < products_key.length; ++i) {
                                        if (typeof products[products_key[i]]['features']['FEATURE_TYPE_SEATING_CHART'] !== 'undefined') {
                                            this.cart_products_seating_chart[products_key[i]] = products[products_key[i]];
                                        }
                                    }
                                    this.cart_is_empty = false;
                                    this.cart_products_quantity = [];

                                    /* set quantity of each product */
                                    for (const [key, value] of Object.entries(products)) {
                                        if (isset(this.cart_products_quantity[value.idx + '-' + value.features['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID']])) {
                                            this.cart_products_quantity[value.idx + '-' + value.features['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID']]++;
                                        } else {
                                            this.cart_products_quantity[value.idx + '-' + value.features['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID']] = 1;
                                        }

                                        /* set le current event */
                                        this.current_event = this.event_list[value.features['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID']];
                                    }

                                } else {
                                    this.cart_products = {};
                                    this.cart_products_seating_chart = {};
                                    this.cart_is_empty = true;
                                    this.cart_products_quantity = [];
                                }

                                this.product_is_loaded = true;
                                this.app_is_loaded = true;
                                resolve('ok');
                            })
                            .catch(error => {
                                this.addErrors('a-104', null, String(error));
                                reject(error);
                            });

                    })
                    .catch(error => {
                        this.addErrors('a-104-2', null, String(error));
                        reject(error);
                    });
            });
        },

        refreshTicketing() {
            let validVide = true;
            let qty_total = 0;
            if (Object.keys(this.ticketing.item).length > 0) {
                for (let key in this.ticketing.item) {
                    if (this.ticketing.item[key].quantity > 0) {
                        validVide = false;
                        qty_total += this.ticketing.item[key].quantity;
                    }
                }
                /*this.ticketing.item.forEach(function(item, index, arr)
                {
                    console.log(item);
                    if(item.quantity > 0)
                    {
                        validVide = false;
                    }
                });*/
            }

            if (qty_total <= 0) {
                this.current_event = null;
            }

            this.disabled_next_btn = validVide;

        },
        reload_borne() {
            window.location.href = this.borne_url;
        },

        removeErrors() {
            this.errors = [];
        },

        set_borne_configuration() {
            this.set_banners();

            if (this.store_id === 439) {
                /* Sags */
                this.borne_configuration.match_img = 'ticket.jpg';
                this.borne_configuration.logo_print_url = 'logo-print-Sags.png';
                this.borne_configuration.modalite_paiement = 'Non-remboursable, ni échangeable.\n' +
                    '                    Toutes personnes ne respectant les consignes de sécurité émises par la Santé publique ainsi que par l\'équipe du Saguenéens peut se voir expulser de l\'aréna, et ce sans préavis.\n' +
                    '                    Frais de transaction :\n' +
                    '                    Les frais de service permettent de couvrir le coût de gestion et de maintenance du système xpayrience.com. Le taux de ces frais peut varier selon l\'organisation et le type de billet que vous achetez. Ces frais ne sont pas remboursables.\n' +
                    '                    Annulation d\'une représentation :\n' +
                    '                    Si une représentation est annulée, vous devez communiquer avec l\'organisation qui vous a vendu les billets afin de connaître les directives de remboursement des billets. Généralement, le remboursement s\'effectuera sur le prix des billets, mais les frais de transaction ne seront pas remboursés.';
            } else if (this.store_id === 418 || this.store_id === 473) {
                /* Pḧoenix*/
                this.borne_configuration.match_img = 'event-place-holder.jpg';
                this.borne_configuration.logo_print_url = 'Logo-Bleu-2019-2020-2.png';
                this.borne_configuration.modalite_paiement = 'Non-remboursable, ni échangeable.\n' +
                    '                    Toutes personnes ne respectant les consignes de sécurité émises par la Santé publique ainsi que par l\'équipe du Phœnix peut se voir expulser de l\'aréna, et ce sans préavis.\n' +
                    '                    Frais de transaction :\n' +
                    '                    Les frais de service permettent de couvrir le coût de gestion et de maintenance du système xpayrience.com. Le taux de ces frais peut varier selon l\'organisation et le type de billet que vous achetez. Ces frais ne sont pas remboursables.\n' +
                    '                    Annulation d\'une représentation :\n' +
                    '                    Si une représentation est annulée, vous devez communiquer avec l\'organisation qui vous a vendu les billets afin de connaître les directives de remboursement des billets. Généralement, le remboursement s\'effectuera sur le prix des billets, mais les frais de transaction ne seront pas remboursés.';
            }
        },

        set_banners() {
            /* La liste des bannières pour chaque store par store_uid */
            this.banners['c3624uxl6priyub9wrqmr68sxmrapoa022v09bse472j76r24bde8h1629119491'] = ['/assets/kiosk/img/stores/c3624uxl6priyub9wrqmr68sxmrapoa022v09bse472j76r24bde8h1629119491/pub-banner.jpg'];
            this.banners['wapykvy8qk1z7g334237870r3ws58bj9y08e02cu16sv5r7m0756fq1651157035'] = ['/assets/kiosk/img/stores/wapykvy8qk1z7g334237870r3ws58bj9y08e02cu16sv5r7m0756fq1651157035/pub-banner.jpg'];
            this.banners['540789zng8960u9m1vvm074l3kn282c223j82qtn43a8e0if9pp2721643737261'] = ['/assets/kiosk/img/stores/540789zng8960u9m1vvm074l3kn282c223j82qtn43a8e0if9pp2721643737261/pub-banner-Saguenay.jpg'];
        },

        set_tpv_to_session() {
            if (this.current_tpv_id !== null && this.current_session_id !== null && this.current_opererator !== null) {
                let session_id = this.current_session_id;
                let data2 = {};
                data2['hardware_device_id'] = this.current_tpv_id;
                data2['hardware_device_operator_uid'] = this.current_opererator;

                return new window.Promise((resolve, reject) => {
                    callAPI(route('api.kiosk.set.tpv.session'), {
                        session_id: session_id,
                        data: data2
                    }, 'post')
                        .then(response => {

                            if (response['data']['success'] === 1) {

                            } else {
                                this.addErrors(response['data']['error'], null, String(error));
                                this.return_error = true;
                            }

                            resolve(response);

                        })
                        .catch(error => {
                            this.addErrors('a-203', null, String(error));
                            reject(error);
                        });
                });
            } else {
                this.$root.errors.push({ code: 'Erreur de tpv' });
                this.return_error = true;
            }
        },

        scrollbarVisible() {
            $('*[show_swipe_up_down]')
                .each(function () {
                    if ($(this)[0].scrollHeight > $(this)[0].clientHeight) {
                        $(this)
                            .attr('show_swipe_up_down', 'Yes');

                    } else {
                        $(this)
                            .attr('show_swipe_up_down', '');
                    }
                });

        },

        setKeepAliveInterval() {
            this.keep_alive_interval = setInterval(() => {
                this.keepAlive();
            }, 60000);
        },

        valid_empty_cart() {
            if (this.app_is_loaded === true) {
                if (this.cart_is_empty) {
                    this.cancel();
                }
            }
        },

        valid_tpv() {
            if (this.current_tpv === null || this.current_tpv_id === null) {
                this.has_call_ajax = [];
                this.current_event_is_loaded = [];
                this.addErrors('Aucun tpv sélectionné!');
                this.$router.push({ name: this.locale + '.summary' })
                    .then(() => {
                    });
                return false;
            }
            return true;
        },

    },

    created: function mounted() {
        this.init();
    },

    template: '<kiosk-component />',

});

app.use(router);

/*
TRANSLATIONS
 */
window.Lang = app.config.globalProperties.trans = new Lang({
    messages: {
        'en.buttons': messages.en.buttons,
        'fr.buttons': messages.fr.buttons,
        'en.common': messages.en.common,
        'fr.common': messages.fr.common,
        'en.errors': messages.en.errors,
        'fr.errors': messages.fr.errors,
        'en.kiosk': messages.en.kiosk,
        'fr.kiosk': messages.fr.kiosk,
        'en.orders': messages.en.orders,
        'fr.orders': messages.fr.orders,
    },
    locale: window.locale,
    fallback: 'fr',
});

app.config.globalProperties.toastr = require('toastr');

/*
GLOBAL SCOPE
 */

/*
MOUNTING APP
 */
app.mount('#app');
